import { useState, useEffect } from "react";
import {
  GetServices,
  UpdateSiteSection,
  GetBarbers,
  DisableSiteSection
} from "./Requests";
import "./SitePages.css";
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import Select from "react-select";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifyError, notifySuccess, notifyWarn } from "../../Response/ResposeHandler";
import { useTranslation } from "react-i18next";

const SiteSections = (props) => {
  const { t } = useTranslation("miniSiteSections");

  const [aboutUsPage, setAboutUsPage] = useState(props.site.aboutUsPageEnabled);
  const [aboutUsPageTitle, setAboutUsPageTitle] = useState(props.site.aboutUsPageTitle);
  const [aboutUsPageDescription, setAboutUsPageDescription] = useState(props.site.aboutUsDescription);

  const [staffPage, setStaffPage] = useState(props.site.staffPageEnabled);
  const [staffPageTitle, setStaffPageTitle] = useState(props.site.staffPageTitle);
  const [staffPageDescription, setStaffPageDescription] = useState(props.site.staffDescription);

  const [servicePage, setServicePage] = useState(props.site.servicePageEnabled);
  const [servicePageTitle, setServicePageTitle] = useState(props.site.servicePageTitle);
  const [servicePageDescription, setServicePageDescription] = useState(props.site.serviceDescription);

  const [noticePage, setNoticePage] = useState(props.site.siteNoticeEnabled);
  const [noticePageTitle, setNoticePageTitle] = useState(props.site.siteNoticeTitle);
  const [noticePageDescription, setNoticePageDescription] = useState(props.site.siteNoticeDescription);

  const errorsAboutObj = { title: "", description: "" };
  const [aboutErrors, setAboutErrors] = useState(errorsAboutObj);
  const errorsNoticeObj = { title: "", description: "" };
  const [noticeErrors, setNoticeErrors] = useState(errorsNoticeObj);
  const errorsServiceObj = { title: "", description: "" };
  const [serviceErrors, setServiceErrors] = useState(errorsServiceObj);
  const errorsStaffObj = { title: "", description: "" };
  const [staffErrors, setStaffErrors] = useState(errorsStaffObj);

  const [services, setServices] = useState([]);
  const [staff, setStaff] = useState([]);
  const [siteServcies, setSiteServices] = useState([]);
  const [siteStaff, setSiteStaff] = useState([]);

  const [aboutSaveButtonLoading, setAboutSaveButtonLoading] = useState(false);
  const [staffSaveButtonLoading, setStaffSaveButtonLoading] = useState(false);
  const [serviceSaveButtonLoading, setServiceSaveButtonLoading] = useState(false);
  const [noticeSaveButtonLoading, setNoticeSaveButtonLoading] = useState(false);

  const [show, setShow] = useState(false);

  useEffect(() => {
    GetServicesWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ClearIndicator = (props) => {
    const { getStyles, innerProps: { ref, ...restInnerProps } } = props;
    return (
      <div {...restInnerProps} ref={ref} style={getStyles("clearIndicator", props)}>
        <div style={{ padding: "0px 5px" }}>{t("common.clear")}</div>
      </div>
    );
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "#525252" : "#7e7e7e"
  });

  function GetServicesWrapper() {
    GetServices()
      .then((res) => {
        const temp = res.data.map((item) => ({
          value: item.serviceId,
          label: item.name,
          isDisabled: item.status === 1 ? false : true
        }));
        setServices(temp);
        const idset = new Set(props.site.servicesIds.map((item) => item));
        const common = temp.filter((item) => idset.has(item.value));
        setSiteServices(common);
      })
      .catch(() => {})
      .finally(() => {
        GetStaffWrapper();
      });
  }

  function GetStaffWrapper() {
    GetBarbers()
      .then((res) => {
        const temp = res.data.map((item) => ({
          value: item.barberId,
          label: item.name,
          isDisabled: item.status === 1 ? false : true
        }));
        setStaff(temp);
        const idset = new Set(props.site.staffIds.map((item) => item));
        const common = temp.filter((item) => idset.has(item.value));
        setSiteStaff(common);
      })
      .catch(() => {})
      .finally(() => {
        setShow(true);
      });
  }

  function PageStatusHandler(e) {
    if (e.target.id === "about") {
      setAboutUsPage(e.target.checked);
      if (!e.target.checked) {
        setAboutErrors({ title: "", description: "" });
        DisableSection(e.target.id);
      }
    }
    if (e.target.id === "staff") {
      setStaffPage(e.target.checked);
      if (!e.target.checked) {
        setStaffErrors({ title: "", description: "" });
        DisableSection(e.target.id);
      }
    }
    if (e.target.id === "service") {
      setServicePage(e.target.checked);
      if (!e.target.checked) {
        setServiceErrors({ title: "", description: "" });
        DisableSection(e.target.id);
      }
    }
    if (e.target.id === "notice") {
      setNoticePage(e.target.checked);
      if (!e.target.checked) {
        setNoticeErrors({ title: "", description: "" });
        DisableSection(e.target.id);
      }
    }
  }

  function SubmitAboutUs() {
    let aboutError = false;
    const next = { ...errorsAboutObj };

    if (!aboutUsPageTitle) {
      next.title = t("errors.sectionTitleRequired");
      aboutError = true;
    }
    if (!aboutUsPageDescription) {
      next.description = t("errors.sectionDescriptionRequired");
      aboutError = true;
    }
    setAboutErrors(next);

    if (aboutError) {
      notifyWarn(t("toasts.invalidDetails"));
    } else {
      setAboutSaveButtonLoading(true);
      UpdateSiteSection(aboutUsPageTitle, aboutUsPageDescription, null, "about", aboutUsPage)
        .then(() => {
          notifySuccess(t("toasts.sectionSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.sectionSaveFailed"));
        })
        .finally(() => {
          props.getSite?.();
          setAboutSaveButtonLoading(false);
        });
    }
  }

  function SubmitNotice() {
    let noticeError = false;
    const next = { ...errorsNoticeObj };

    if (!noticePageTitle) {
      next.title = t("errors.sectionTitleRequired");
      noticeError = true;
    }
    if (!noticePageDescription) {
      next.description = t("errors.sectionDescriptionRequired");
      noticeError = true;
    }
    setNoticeErrors(next);

    if (noticeError) {
      notifyWarn(t("toasts.invalidDetails"));
    } else {
      setNoticeSaveButtonLoading(true);
      UpdateSiteSection(noticePageTitle, noticePageDescription, null, "notice", noticePage)
        .then(() => {
          notifySuccess(t("toasts.sectionSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.sectionSaveFailed"));
        })
        .finally(() => {
          props.getSite?.();
          setNoticeSaveButtonLoading(false);
        });
    }
  }

  function SubmitServiceSection() {
    let serviceError = false;
    const next = { ...errorsServiceObj };

    if (!servicePageTitle) {
      next.title = t("errors.sectionTitleRequired");
      serviceError = true;
    }
    setServiceErrors(next);

    if (serviceError) {
      notifyWarn(t("toasts.invalidDetails"));
    } else {
      setServiceSaveButtonLoading(true);
      UpdateSiteSection(
        servicePageTitle,
        servicePageDescription,
        siteServcies.map((w) => w.value),
        "service",
        servicePage
      )
        .then(() => {
          notifySuccess(t("toasts.sectionSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.sectionSaveFailed"));
        })
        .finally(() => {
          props.getSite?.();
          setServiceSaveButtonLoading(false);
        });
    }
  }

  function SubmitStaffSection() {
    let staffError = false;
    const next = { ...errorsStaffObj };

    if (!staffPageTitle) {
      next.title = t("errors.sectionTitleRequired");
      staffError = true;
    }
    setStaffErrors(next);

    if (staffError) {
      notifyWarn(t("toasts.invalidDetails"));
    } else {
      setStaffSaveButtonLoading(true);
      UpdateSiteSection(
        staffPageTitle,
        staffPageDescription,
        siteStaff.map((w) => w.value),
        "staff",
        staffPage
      )
        .then(() => {
          notifySuccess(t("toasts.sectionSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.sectionSaveFailed"));
        })
        .finally(() => {
          props.getSite?.();
          setStaffSaveButtonLoading(false);
        });
    }
  }

  function DisableSection(sectionName) {
    DisableSiteSection(sectionName)
      .then(() => {
        notifySuccess(t("toasts.sectionDisabled"));
      })
      .catch(() => {
        notifyError(t("toasts.sectionDisableFailed"));
      })
      .finally(() => {
        props.getSite?.();
      });
  }

  return (
    <div className="sectionsWrap">
      <ToastContainer />

      <div className="sectionsGrid">
        {/* ====== ABOUT ====== */}
        <section className="sectionCard">
          <header className="sectionHead">
            <div className="sectionTitle">
              <h3>{t("about.title")}</h3>
              <p className="sectionSub">{t("about.subtitle")}</p>
            </div>
            <div className="sectionToggle">
              <input
                className="toggle-switch"
                type="checkbox"
                checked={aboutUsPage}
                id="about"
                onChange={PageStatusHandler}
              />
              <label htmlFor="about" className="switch-label" />
            </div>
          </header>

          {aboutUsPage && (
            <div className="sectionBody">
              <div className="sm-field">
                <label htmlFor="about-us-title" className="sm-label">
                  {t("fields.sectionTitle")}
                </label>
                <input
                  id="about-us-title"
                  type="text"
                  maxLength={30}
                  className="sm-input"
                  placeholder={t("about.placeholders.title")}
                  value={aboutUsPageTitle}
                  onChange={(e) => setAboutUsPageTitle(e.target.value)}
                />
                {aboutErrors.title && <div className="sm-error">{aboutErrors.title}</div>}
              </div>

              <div className="sm-field">
                <label className="sm-label">{t("fields.sectionDescription")}</label>
                <textarea
                  rows={4}
                  maxLength={300}
                  className="sm-input sm-textarea"
                  placeholder={t("about.placeholders.description")}
                  value={aboutUsPageDescription}
                  onChange={(e) => setAboutUsPageDescription(e.target.value)}
                />
                {aboutErrors.description && <div className="sm-error">{aboutErrors.description}</div>}
              </div>

              <div className="sectionActions">
                <CustomButton
                  disabled={aboutSaveButtonLoading}
                  className="app-btn--sm"
                  onClick={SubmitAboutUs}
                  label={t("actions.save")}
                  loading={aboutSaveButtonLoading}
                />
              </div>
            </div>
          )}
        </section>

        {/* ====== SERVICES ====== */}
        <section className="sectionCard">
          <header className="sectionHead">
            <div className="sectionTitle">
              <h3>{t("services.title")}</h3>
              <p className="sectionSub">{t("services.subtitle")}</p>
            </div>
            <div className="sectionToggle">
              <input
                className="toggle-switch"
                type="checkbox"
                checked={servicePage}
                id="service"
                onChange={PageStatusHandler}
              />
              <label htmlFor="service" className="switch-label" />
            </div>
          </header>

          {servicePage && (
            <div className="sectionBody">
              <div className="sm-field">
                <label className="sm-label">{t("fields.selectServices")}</label>
                {show && (
                  <Select
                    isSearchable={false}
                    isMulti
                    closeMenuOnSelect={false}
                    components={{ ClearIndicator }}
                    styles={{ clearIndicator: ClearIndicatorStyles }}
                    defaultValue={siteServcies}
                    options={services}
                    onChange={(e) => setSiteServices(e)}
                    className="sm-select"
                    classNamePrefix="rs"
                  />
                )}
              </div>

              <div className="sm-field">
                <label htmlFor="services-title" className="sm-label">
                  {t("fields.sectionTitle")}
                </label>
                <input
                  id="services-title"
                  type="text"
                  maxLength={30}
                  className="sm-input"
                  placeholder={t("services.placeholders.title")}
                  value={servicePageTitle}
                  onChange={(e) => setServicePageTitle(e.target.value)}
                />
                {serviceErrors.title && <div className="sm-error">{serviceErrors.title}</div>}
              </div>

              <div className="sm-field">
                <label className="sm-label">{t("fields.sectionDescription")}</label>
                <textarea
                  rows={4}
                  maxLength={300}
                  className="sm-input sm-textarea"
                  placeholder={t("services.placeholders.description")}
                  value={servicePageDescription}
                  onChange={(e) => setServicePageDescription(e.target.value)}
                />
                {serviceErrors.description && <div className="sm-error">{serviceErrors.description}</div>}
              </div>

              <div className="sectionActions">
                <CustomButton
                  disabled={serviceSaveButtonLoading}
                  className="app-btn--sm"
                  onClick={SubmitServiceSection}
                  label={t("actions.save")}
                  loading={serviceSaveButtonLoading}
                />
              </div>
            </div>
          )}
        </section>

        {/* ====== STAFF ====== */}
        <section className="sectionCard">
          <header className="sectionHead">
            <div className="sectionTitle">
              <h3>{t("staff.title")}</h3>
              <p className="sectionSub">{t("staff.subtitle")}</p>
            </div>
            <div className="sectionToggle">
              <input
                className="toggle-switch"
                type="checkbox"
                checked={staffPage}
                id="staff"
                onChange={PageStatusHandler}
              />
              <label htmlFor="staff" className="switch-label" />
            </div>
          </header>

          {staffPage && (
            <div className="sectionBody">
              <div className="sm-field">
                <label className="sm-label">{t("fields.selectStaff")}</label>
                {show && (
                  <Select
                    isSearchable={false}
                    isMulti
                    closeMenuOnSelect={false}
                    components={{ ClearIndicator }}
                    styles={{ clearIndicator: ClearIndicatorStyles }}
                    defaultValue={siteStaff}
                    options={staff}
                    onChange={(e) => setSiteStaff(e)}
                    className="sm-select"
                    classNamePrefix="rs"
                  />
                )}
              </div>

              <div className="sm-field">
                <label htmlFor="staff-title" className="sm-label">
                  {t("fields.sectionTitle")}
                </label>
                <input
                  id="staff-title"
                  type="text"
                  maxLength={30}
                  className="sm-input"
                  placeholder={t("staff.placeholders.title")}
                  value={staffPageTitle}
                  onChange={(e) => setStaffPageTitle(e.target.value)}
                />
                {staffErrors.title && <div className="sm-error">{staffErrors.title}</div>}
              </div>

              <div className="sm-field">
                <label className="sm-label">{t("fields.sectionDescription")}</label>
                <textarea
                  rows={4}
                  maxLength={300}
                  className="sm-input sm-textarea"
                  placeholder={t("staff.placeholders.description")}
                  value={staffPageDescription}
                  onChange={(e) => setStaffPageDescription(e.target.value)}
                />
                {staffErrors.description && <div className="sm-error">{staffErrors.description}</div>}
              </div>

              <div className="sectionActions">
                <CustomButton
                  disabled={staffSaveButtonLoading}
                  className="app-btn--sm"
                  onClick={SubmitStaffSection}
                  label={t("actions.save")}
                  loading={staffSaveButtonLoading}
                />
              </div>
            </div>
          )}
        </section>

        {/* ====== NOTICE ====== */}
        <section className="sectionCard">
          <header className="sectionHead">
            <div className="sectionTitle">
              <h3>{t("notice.title")}</h3>
              <p className="sectionSub">{t("notice.subtitle")}</p>
            </div>
            <div className="sectionToggle">
              <input
                className="toggle-switch"
                type="checkbox"
                checked={noticePage}
                id="notice"
                onChange={PageStatusHandler}
              />
              <label htmlFor="notice" className="switch-label" />
            </div>
          </header>

          {noticePage && (
            <div className="sectionBody">
              <div className="sm-field">
                <label htmlFor="notice-title" className="sm-label">
                  {t("fields.noticeTitle")}
                </label>
                <input
                  id="notice-title"
                  type="text"
                  maxLength={30}
                  className="sm-input"
                  placeholder={t("notice.placeholders.title")}
                  value={noticePageTitle}
                  onChange={(e) => setNoticePageTitle(e.target.value)}
                />
                {noticeErrors.title && <div className="sm-error">{noticeErrors.title}</div>}
              </div>

              <div className="sm-field">
                <label className="sm-label">{t("fields.noticeDescription")}</label>
                <textarea
                  rows={4}
                  maxLength={300}
                  className="sm-input sm-textarea"
                  placeholder={t("notice.placeholders.description")}
                  value={noticePageDescription}
                  onChange={(e) => setNoticePageDescription(e.target.value)}
                />
                {noticeErrors.description && <div className="sm-error">{noticeErrors.description}</div>}
              </div>

              <div className="sectionActions">
                <CustomButton
                  disabled={noticeSaveButtonLoading}
                  className="app-btn--sm"
                  onClick={SubmitNotice}
                  label={t("actions.save")}
                  loading={noticeSaveButtonLoading}
                />
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default SiteSections;
